import React from "react";
import { Badge } from "../Base/Badge";
import type { MailIconProps } from "./MailIcon.types";
import { useMessageNotification } from "../../modules/notification";
import "./MailIcon.scss";
import { MailTopRightIcon as MailSvgIcon } from "./IconSvgMap";

export const MailIcon: React.FC<MailIconProps> = ({
  badgeContent: externalBadgeContent,
  showBadge: externalShowBadge,
  showDot = false,
  showCount = true,
  maxCount = 99,
  onBadgeClick,
  className = "",
  onClick,
}) => {
  // 直接使用 useMessageNotification 获取未读消息数
  const { messageUnreadCount } = useMessageNotification();

  // 处理点击事件
  const handleClick = () => {
    // 调用自定义点击回调
    onBadgeClick?.();
    onClick?.();
  };

  // 确定最终显示的内容和状态
  const finalBadgeContent =
    externalBadgeContent !== undefined
      ? externalBadgeContent
      : messageUnreadCount;
  const finalShowBadge =
    externalShowBadge !== undefined
      ? externalShowBadge
      : messageUnreadCount > 0;
  const shouldShowDot = showDot && !showCount && messageUnreadCount > 0;
  const shouldShowCount =
    showCount && typeof finalBadgeContent === "number" && finalBadgeContent > 0;

  const displayContent =
    typeof finalBadgeContent === "number" && finalBadgeContent > maxCount
      ? `${maxCount}+`
      : finalBadgeContent;

  return (
    <div className={`mail-icon ${className}`.trim()}>
      {finalShowBadge ? (
        <Badge
          content={
            shouldShowDot
              ? undefined
              : shouldShowCount
                ? displayContent
                : undefined
          }
          dot={shouldShowDot}
          variant="error"
          size="sm"
          className="mail-icon__badge"
        >
          <MailSvgIcon
            width="100%"
            height="100%"
            className="mail-icon__image"
            onClick={handleClick}
          />
        </Badge>
      ) : (
        <MailSvgIcon
          width="100%"
          height="100%"
          className="mail-icon__image"
          onClick={handleClick}
        />
      )}
    </div>
  );
};

export default MailIcon;
